import "./garlic.js"
import "./search-filter.js"

$( function() {
  var $body = $('body');
  var ua = navigator.userAgent.toLowerCase();

  // anchor link
  function anchorLink() {
    $(document).on('click', 'a[href^="#"]', function(e) {
      e.preventDefault();

      var $el     = $(this);
      var $target = $($el.attr('href'));
      var paddingTop = 70;

      if (!$target[0]) {
        return;
      }

      var offset = $target.offset().top;
      $('html, body').animate({scrollTop: offset - paddingTop});
    });
  }

  function navControl() {
    var $navBtn = $('#js-navBtn');
    var $nav = $('#js-nav');

    $navBtn.on('click', function() {
      if ( $navBtn.hasClass('is-open') ) {
        $nav.fadeOut(300);
      } else {
        $nav.fadeIn(300);
      }
      $navBtn.toggleClass('is-open');
      $body.toggleClass('nav-open');
    });

    $('body').on('click', function() {
      if ( $navBtn.hasClass('is-open') ) {
        $nav.fadeOut(300);
        $navBtn.toggleClass('is-open');
        $body.toggleClass('nav-open');
      }
    });

    $('#js-nav, #js-navBtn').on( 'click', function(e) {
      e.stopPropagation();
    });

  }

  function accordion() {
    $('.js-accordionToggle').on('click', function(e) {
      e.preventDefault();
      $(this).next('.js-accordionContent').slideToggle();
      $(this).parent('.js-accordion').toggleClass('is-open');

      if ( $body.hasClass('p-archive') ) {
        sfSetPadding();
      }
      return false;
    });
  }

  function sfSetPadding() {
    $('.sf-input-checkbox').each(function(i, el) {
      var children = $(el).nextAll('.children');
      var parent = $(el).parent('li');

      if( children.length ) {
        // console.log(children.height())
        if ( parent.hasClass('sf-option-active') ) {
          parent.css('padding-bottom', children.height());
          children.addClass('is-visible');
        } else {
          parent.css('padding-bottom', 0);
          children.removeClass('is-visible');
        }
      }
    });
  }

  function preventSubmit() {
    var inputs = document.getElementsByClassName('wpcf7-form-control');
    for(var i=0; i<inputs.length; i++){
      if(inputs[i].type == 'email' || inputs[i].type == 'password'|| inputs[i].type == 'text'|| inputs[i].type == 'number'|| inputs[i].type == 'tel'){
        inputs[i].onkeypress = function (e){
          if (!e) var e = window.event;
          if(e.keyCode == 13) return false;
        };
      }
    }
  }

  // fire when DOM is ready
  $(function() {
    anchorLink();
    navControl();
    accordion();
    preventSubmit();
  });

  // fire when page is fully loaded
  $(window).on('load',function(){
  });

});
